var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import './Menubar.css';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
let Menubar_ = class Menubar_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (runtime.browserRuntime && runtime.browserRuntime.browserFullscreen.isInFullscreen) {
            return null;
        }
        if (app.appInfo.isAppInEditBuild) {
            const { EditMenubar_ } = runtime.availablePackages.Edit.components;
            return React.createElement(EditMenubar_, { app: app });
        }
        if (app.menubar.isMenubarPhone) {
            if (!runtime.streamedPackages.Mobile)
                return null;
            const { MenubarMobile_ } = runtime.streamedPackages.Mobile.components;
            return React.createElement(MenubarMobile_, { app: app });
        }
        if (!runtime.streamedPackages.Large)
            return null;
        const { MenubarLarge_ } = runtime.streamedPackages.Large.components;
        return React.createElement(MenubarLarge_, { app: app });
    }
};
Menubar_ = __decorate([
    observer
], Menubar_);
export { Menubar_ };
